import { v2ApiClient } from "../apiClient";

export const alertDevice = (tid: string, duration: number, waitForResponse: boolean) =>
  v2ApiClient.post<void>(
    `/api/v2/device/${encodeURIComponent(tid)}/alert`,
    { duration },
    { wait_for_response: waitForResponse }
  );
